import React, { Component, Fragment } from 'react';
import { PageWrapper, ErrorRedirect, PageLoader, SocialShare, RelatedPosts } from './../components/';
import FilmProjectTop from './../components/photo-film-project/FilmProjectTop';
import FlexiblePortfolioLayout from './../components/photo-film-project/FlexiblePortfolioLayout';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    this.slug = `${process.env.API_URL}film/?name=`;
  }

  componentDidMount() {
    this._apiRequest(`${this.slug}${this.props.match.params.pageSlug}`);
  }
  
  componentWillReceiveProps(nextProps) {
    this._apiRequest(`${this.slug}${nextProps.match.params.pageSlug}`);
  }

  _apiRequest(url) {
    fetch(url).then((response) => {
      if (!response.ok) { throw Error(response.statusText); }
      return response.json();
    }).then((res) => {
      this.setState({
        wpData: res.data,
        loading: false,
        error: false
      });
    }).catch(() => {
      this.setState({
        error: true,
        loading: false,
        wpData: false
      });
    });
  }

  render() {
    return (
      <Fragment>
        {(this.state.loading) ? <PageLoader/> : (this.state.error) ? <ErrorRedirect/>
          : <FilmContent data={this.state.wpData}/>
        }
      </Fragment>
    );
  };
};

const FilmContent = (props) => {
  return (
    <PageWrapper pageId={'photo-film-project'}>
      <FilmProjectTop FilmData={props.data}/>
      {(props.data.portfolio_layout.length !== 0) && 
        <FlexiblePortfolioLayout LayoutItems={props.data.portfolio_layout} />
      }
      <SocialShare Meta={props.data.page_meta} />
      <RelatedPosts Posts={props.data.related_posts.posts}/>
    </PageWrapper>
  );
};



// WEBPACK FOOTER //
// ./src/pages/SingleFilm.js